import {LINK_MAP, LinkEnum} from "appConstants";
import {env} from "core/env";

/**
 * Check if we are currently living within an iframe
 * This is helpful to patch some unexpected behavior around modals
 */
export function isIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

/**
 * Replaces placeholders in a template string with corresponding values from an array.
 * @param {string} template - The template string containing placeholders (%s).
 * @param {string[]} args - The array of values to replace the placeholders.
 * @returns {string} - The formatted string with placeholders replaced by corresponding values.
 */
export function replacer(template: string, args: string[]): string {
    let i = 0;
    return template.replace(/%s/g, () => args[i++] || "");
}

/**
 * Retrieves a formatted link based on a key and arguments.
 * @param {LinkEnum} key - The key to identify the link template from LINK_MAP.
 * @param {string[]} args - The array of values to replace the placeholders in the link template.
 * @returns {string} - The formatted link with placeholders replaced by corresponding values.
 */
export function getLink(key: LinkEnum, args: string[]): string {
    return replacer(LINK_MAP.get(key) || "", args);
}

/**
 * Retrieves a formatted ticket link based on the ticket ID.
 * @param {string} ticketId - The ID of the ticket.
 * @returns {string} - The formatted ticket link.
 */
export function getTicketLink(ticketId: string): string {
    return getLink(LinkEnum.ADMIN_LEGACY, [env.REACT_APP_ADMIN_URL, ticketId]);
}

/**
 * Formats a number as a currency string.
 * @param {number} value - The number to format.
 * @returns {string} - The formatted currency string.
 */
export function formatCurrency(value: number): string {
    return `$${value.toLocaleString()}`;
}
